/* eslint-disable no-undef */
import { memo, useContext, useEffect, useState, useRef } from 'react';
import Axios from 'axios';
import DashboardContext from '../../../Context';
import Select from 'react-select';

const B2BAmountPerHourInfo = ({
  groupId,
  dataUpdate,
  periodTime,
  appType,
  startWork,
  priceListId,
  orderScheduleId,
  handleChange,
}) => {
  const { authentication, urldashboard, handelerrors } =
    useContext(DashboardContext);

  const selectInputRef = useRef();
  const [Loading, setLoading] = useState(true);
  const [dataFech, setDataFech] = useState({});
  const [priceOptions, setPriceOptions] = useState([]);

  const dataFeching = async () => {
    setLoading(true);
    try {
      const res = await Axios.post(
        `${urldashboard}/businessToBusinessOrder/CalculateCustomAmount`,
        JSON.stringify({
          groupId,
          priceListId: priceListId,
          customHour: periodTime,
          startWork: startWork,
          orderScheduleId: orderScheduleId,
          appType: appType,
        }),
        {
          headers: {
            Authorization: authentication,
            'Content-Type': 'application/json; charset=utf-8 ',
          },
        }
      );
      const data = await res?.data?.data;
      data?.amountsPerHour?.value?.map(
        (item) =>
          (item.label = item?.label
            ?.toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ','))
      );
      setPriceOptions(data?.amountsPerHour?.value);
      setLoading(false);
    } catch (error) {
      setPriceOptions([]);
      handleChange({
        priceListId: null,
      });
      handelerrors(error);
      setLoading(false);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {
    if (
      dataUpdate.customAmountFemaleWorker ||
      dataUpdate.customAmountMaleWorker
    ) {
      setDataFech({
        amountPerHour:
          dataUpdate?.customAmountMaleWorker ||
          dataUpdate?.customAmountFemaleWorker ||
          0,
      });
      setLoading(false);
    }
    dataFeching();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groupId, periodTime, startWork]);

  const handelValue = (value) => {
    handleChange({
      priceListId: value?.value,
      isMale: true,
    });
  };

  return (
    <>
      {Loading ? (
        <i className='fa-li fa fa-spinner fa-spin'></i>
      ) : (
        <>
          <span>قیمت ها</span>
          <div style={{ marginTop: 10 }}>
            <Select
              className='basic-single'
              classNamePrefix='select'
              styles={{ menu: (provided) => ({ ...provided, zIndex: 9999 }) }}
              ref={selectInputRef}
              defaultValue={priceOptions?.find(
                (item) => item.value === priceListId
              )}
              onChange={handelValue}
              isRtl
              isClearable
              name='priceId'
              options={[
                {
                  label: 'هزینه نیرو آقا/خانم ساعتی',
                  options: priceOptions,
                },
              ]}
            />
          </div>
        </>
      )}
    </>
  );
};

export default memo(B2BAmountPerHourInfo);
